var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-highlight',{staticClass:"c-highlight--hero",attrs:{"product":_vm.product}},[_c('h3',{staticClass:"o-typography__headline1"},[_vm._v(" "+_vm._s(_vm.product.title)+" ")]),_c('p',{staticClass:"o-typography__body1 u-desktop-only"},[_vm._v(" "+_vm._s(_vm.product.lead)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }